<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<crucible-dialog
  [dialogTitle]="data.card?.id ? 'Edit Card' : 'Add a Card'"
  [form]="form"
  submitLabel="Save"
  [submitDisabled]="!errorFree() || !form.dirty"
  [guardUnsavedWork]="form.dirty"
  (submit)="handleEditComplete(true)"
  (cancel)="handleEditComplete(false)"
>
  @if (!!data && data.card !== undefined && data.card !== null) {
    <div crucibleDialogContent>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input type="text" matInput [formControl]="cardNameFormControl" placeholder="Name (required)"
              (blur)="saveCard('name')" value="{{data.card.name}}">
            @if (cardNameFormControl.hasError('required')) {
            <mat-error>
              Name is <strong>required</strong>
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Description</mat-label>
            <textarea matInput [formControl]="cardDescriptionFormControl" placeholder="Description"
              (blur)="saveCard('description')" value="{{data.card.description}}"></textarea>
          </mat-form-field>
        </div>
      </div>
    </div>
  }
</crucible-dialog>
